export default __webpack_public_path__ + "static/media/whitegoose13.a5f87106.jpg";